/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

export default function DropDownModule(Component) {
	return class DropDownModule extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				iconImageValid: true
			};

			this.onClick = this.onClick.bind(this);

		}

		onClick(event) {

			event.preventDefault();
			event.stopPropagation();

			this.props.clickHandler(this.props.item, event);

		}

		render() {
			return (
				<Component onClick={this.onClick} {...this.props}/>
			);
		}

	};
	DropDownDecorator.propTypes = {
		key: PropTypes.oneOfType([
			PropTypes.number,
			PropTypes.string
		]),
		item: PropTypes.object,
		clickHandler: PropTypes.func,
		itemActive: PropTypes.bool
	};
	DropDownDecorator.defaultProps = {
		key: 0,
		item: {},
		clickHandler: null,
		itemActive: false
	};
	DropDownDecorator.displayName = "DropDownDecorator";

};
